import { render, staticRenderFns } from "./Process.vue?vue&type=template&id=1f2370f8&scoped=true"
import script from "./Process.vue?vue&type=script&lang=js"
export * from "./Process.vue?vue&type=script&lang=js"
import style0 from "./Process.vue?vue&type=style&index=0&id=1f2370f8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2370f8",
  null
  
)

export default component.exports